export const DEFAULT_ITEMS_PER_PAGE = 10;

export const ITEMS_PER_PAGE_OPTIONS = [
  { key: "10", text: "10" },
  { key: "20", text: "20" },
  { key: "30", text: "30" },
  { key: "40", text: "40" },
  { key: "50", text: "50" },
  { key: "100", text: "100" },
  { key: "500", text: "500" },
  { key: "1000", text: "1000" }
];
